/* eslint react/no-danger: 0 */  // --> OFF
import PropTypes from "prop-types";

import React, { Component } from "react";

export default class ReadOnlyFieldInLine extends Component {

  rawMarkup(fieldValue) {
    return { __html: fieldValue };
  }

  render() {
    let { fieldValue, title, rawHtml, link, emptyText, containerClassName } = this.props;
    if (fieldValue == undefined || fieldValue == null || fieldValue.length == 0) {
      fieldValue = (emptyText == undefined || emptyText.length ==0) ? "Not provided" : emptyText;
    }

    let fValFunc = () => {
      return (
        <div>
        {
          (rawHtml === true)
            ? <div className={"md-full-width"} style={{marginBottom: 8, fontWeight: 500}} dangerouslySetInnerHTML={this.rawMarkup(fieldValue)} />
            : <div className={"md-full-width"} style={{marginBottom: 8, fontWeight: 500}}>{fieldValue}</div>
        }    
        </div>    
      );
    };
    let fVal = fValFunc();

    return (
      <div style={{display:"inline"}} className={`${containerClassName} md-text-field-container md-full-width md-text-field-container--disabled md-text-field-container--input`}>
        <span className={"ReadOnlyFieldInLineTitle md-floating-label--disabled"}>
          {title}
        </span>
        {
          (link)
            ? <a href={link} target="_blank">{fVal}</a>
            : <div>{fVal}</div>
        }
      </div>
    );
  }
}

ReadOnlyFieldInLine.propTypes = {
  fieldValue: PropTypes.string,
  title: PropTypes.string,
  rawHtml: PropTypes.bool,
  link: PropTypes.string,
  emptyText: PropTypes.string,
  containerClassName: PropTypes.string
};

